import * as pbi from 'powerbi-client';

export const powerBiService = new pbi.service.Service(
    pbi.factories.hpmFactory,
    pbi.factories.wpmpFactory,
    pbi.factories.routerFactory,
);
